import { useEmployment } from "providers/employee/EmploymentProvider";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

export const isActiveAssignment = (endDate?: string | null) => {
  if (!endDate) return true;
  return new Date(endDate) >= new Date();
};

export const useActiveProductAssignment = () => {
  const { employment, loading } = useEmployment();
  const { productAssignmentId } = useParams();

  const productAssignments = employment?.productAssignments ?? [];

  const currentAssignment = useMemo(
    () => productAssignments.find((item) => item.id === productAssignmentId),
    [productAssignments, productAssignmentId],
  );

  const isCurrentActive = useMemo(
    () => !!currentAssignment && isActiveAssignment(currentAssignment.endDate),
    [currentAssignment],
  );

  const activeAssignments = useMemo(
    () =>
      productAssignments.filter((assignment) =>
        isActiveAssignment(assignment.endDate),
      ),
    [productAssignments],
  );

  const activeAssignmentId = isCurrentActive
    ? currentAssignment?.id
    : activeAssignments[0]?.id;

  return {
    productAssignments,
    currentAssignment,
    isCurrentActive,
    activeAssignments,
    activeAssignmentId,
    loading,
  };
};
